import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/services";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (i % 4) * 0.08 },
  }),
};

export const Services = () => (
  <section id="servizi" className="relative py-24 lg:py-32 bg-[#0A0A0B]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14"
      >
        <div>
          <p className="font-mono-tac text-xs tracking-[0.3em] text-[#FFD500] uppercase font-bold mb-4">[ 01 — Cosa Facciamo ]</p>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-white" data-testid="services-title">
            I Nostri <span className="text-[#FFD500]">Servizi</span>
          </h2>
        </div>
        <p className="max-w-sm text-neutral-400 text-sm leading-relaxed">
          Dodici aree di intervento, una sola squadra. Dalla messa in sicurezza d'emergenza al ripristino finito, seguiamo ogni fase con mezzi e operatori propri.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[240px] gap-3" data-testid="services-grid">
        {SERVICES.map((s, i) => (
          <motion.a
            key={s.id}
            href="#contatti"
            custom={i}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className={`group relative overflow-hidden bg-[#121215] border border-white/5 ${s.span}`}
            data-testid={`service-card-${s.id}`}
          >
            <img
              src={s.image}
              alt={s.title}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover opacity-50 transition-all duration-700 ease-out group-hover:opacity-70 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            <div className="absolute top-0 left-0 w-full h-1 bg-[#FFD500] scale-x-0 origin-left transition-transform duration-500 group-hover:scale-x-100" />

            <div className="relative h-full flex flex-col justify-between p-5">
              <div className="flex items-start justify-between">
                <span className="font-mono-tac text-[10px] tracking-[0.2em] text-[#FFD500] border border-[#FFD500]/30 bg-black/50 backdrop-blur-sm px-2 py-1">
                  {s.tag}
                </span>
                <ArrowUpRight
                  size={20}
                  className="text-white/40 transition-all duration-300 group-hover:text-[#FFD500] group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
              <div>
                <h3 className="font-display font-bold uppercase text-xl sm:text-2xl text-white tracking-wide leading-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-xs text-neutral-300 leading-relaxed max-h-0 opacity-0 overflow-hidden transition-all duration-500 group-hover:max-h-24 group-hover:opacity-100">
                  {s.desc}
                </p>
              </div>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
